import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { Animator } from '@swift-paypal/pp-react-animator';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FocusOn, AutoFocusInside } from 'react-focus-on';
import { IconButton } from '@swift-paypal/pp-react-icon-button';
import { V2CloseIcon, CloseIcon } from '@swift-paypal/pp-react-icons';
import { useTheme } from '@swift-paypal/pp-react-theme';
import clsx from 'clsx';
import '../__generated__/styles/dialog.css';

var styles = {"ppvx_modal--container_middle":"ppvx_modal--container_middle___1-4-1","ppvx_modal--container_bottom":"ppvx_modal--container_bottom___1-4-1","ppvx_modal":"ppvx_modal___1-4-1","ppvx_modal--overpanel":"ppvx_modal--overpanel___1-4-1","ppvx_modal--sheet":"ppvx_modal--sheet___1-4-1","ppvx_modal-backdrop":"ppvx_modal-backdrop___1-4-1","ppvx_modal-backdrop--show":"ppvx_modal-backdrop--show___1-4-1","ppvx_scrim":"ppvx_scrim___1-4-1","ppvx_scrim--show":"ppvx_scrim--show___1-4-1","ppvx_modal__contents":"ppvx_modal__contents___1-4-1","ppvx_modal-header":"ppvx_modal-header___1-4-1","ppvx_modal__contents--no-padding":"ppvx_modal__contents--no-padding___1-4-1","ppvx_modal__contents--center":"ppvx_modal__contents--center___1-4-1","ppvx_modal__screenreader":"ppvx_modal__screenreader___1-4-1","ppvx_modal-header__close":"ppvx_modal-header__close___1-4-1","ppvx_modal-header__action":"ppvx_modal-header__action___1-4-1","ppvx_modal-header--gripper":"ppvx_modal-header--gripper___1-4-1","ppvx_modal-header--divider":"ppvx_modal-header--divider___1-4-1","ppvx_modal-header--scrolled":"ppvx_modal-header--scrolled___1-4-1","ppvx_modal-header__title":"ppvx_modal-header__title___1-4-1","ppvx_modal-header__work-area":"ppvx_modal-header__work-area___1-4-1","ppvx_modal__contents--close":"ppvx_modal__contents--close___1-4-1","ppvx_modal-header__close-btn":"ppvx_modal-header__close-btn___1-4-1","ppvx_modal-content__title":"ppvx_modal-content__title___1-4-1","ppvx_modal-header--no-logo":"ppvx_modal-header--no-logo___1-4-1","ppvx_modal-footer":"ppvx_modal-footer___1-4-1","ppvx_modal-footer--scrolled":"ppvx_modal-footer--scrolled___1-4-1","ppvx_modal-footer--align_center":"ppvx_modal-footer--align_center___1-4-1","ppvx_modal-footer--align_right":"ppvx_modal-footer--align_right___1-4-1","ppvx_visible-only-in-context":"ppvx_visible-only-in-context___1-4-1","ppvx_modal--sheet--height_90":"ppvx_modal--sheet--height_90___1-4-1","ppvx_modal-header__close-btn--svg":"ppvx_modal-header__close-btn--svg___1-4-1","ppvx--v2":"ppvx--v2___1-4-1","ppvx--v1":"ppvx--v1___1-4-1"};

var uniqueId = function () {
  return (Math.random() * 100000000).toFixed(0).toString();
};

var DialogComponent = function (_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4;

  var isFullView = _ref.isFullView,
      showInverseCloseButton = _ref.showInverseCloseButton,
      requestClose = _ref.requestClose,
      className = _ref.className,
      headerClassName = _ref.headerClassName,
      footerClassName = _ref.footerClassName,
      containerClassName = _ref.containerClassName,
      isHidden = _ref.isHidden,
      center = _ref.center,
      divider = _ref.divider,
      _ref$hideTitle = _ref.hideTitle,
      hideTitle = _ref$hideTitle === void 0 ? isFullView : _ref$hideTitle,
      _ref$closeButtonLabel = _ref.closeButtonLabel,
      closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'Close Dialog' : _ref$closeButtonLabel,
      closeOnBackgroundClick = _ref.closeOnBackgroundClick,
      title = _ref.title,
      id = _ref.id,
      action = _ref.action,
      footerContents = _ref.footerContents,
      footerAlign = _ref.footerAlign,
      children = _ref.children,
      containerRef = _ref.containerRef,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["isFullView", "showInverseCloseButton", "requestClose", "className", "headerClassName", "footerClassName", "containerClassName", "isHidden", "center", "divider", "hideTitle", "closeButtonLabel", "closeOnBackgroundClick", "title", "id", "action", "footerContents", "footerAlign", "children", "containerRef", "theme"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setIsMounted = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      headerScroll = _useState4[0],
      setHeaderScroll = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      footerScroll = _useState6[0],
      setFooterScroll = _useState6[1];

  var contentRef = useRef();
  var idBase = id || uniqueId(); // jest has no way to test things like scrollTop or scrollHeight --BCC

  /* istanbul ignore next */

  var scrollCheck = function () {
    if (contentRef && contentRef.current) {
      var _contents = contentRef.current;
      var newHeaderScroll = _contents.scrollTop !== 0;

      if (newHeaderScroll !== headerScroll) {
        setHeaderScroll(newHeaderScroll);
      } // Footer is optional, may not be one to watch for!


      if (footerContents) {
        // Have we scrolled to the bottom?
        var newFooterScroll = _contents.scrollTop + _contents.offsetHeight !== _contents.scrollHeight;

        if (newFooterScroll !== footerScroll) {
          setFooterScroll(newFooterScroll);
        }
      }
    }
  };

  useEffect(function () {
    setIsMounted(true);
  }, []);
  useEffect(function () {
    if (!isHidden) {
      scrollCheck();
    }
  }, [isHidden]);
  /* istanbul ignore next */

  var _theme = useTheme('Dialog', theme);

  var isThemeV2 = _theme && _theme === 'v2';
  var wrapperClasses = clsx(styles['ppvx_modal-backdrop'], (_clsx = {}, _defineProperty(_clsx, styles['ppvx_modal-backdrop--show'], !isHidden), _defineProperty(_clsx, styles['ppvx--v2'], isThemeV2), _clsx));
  var classes = clsx(styles.ppvx_modal, containerClassName);
  var contentClasses = clsx(styles.ppvx_modal__contents, (_clsx2 = {}, _defineProperty(_clsx2, styles['ppvx_modal__contents--center'], center), _defineProperty(_clsx2, styles['ppvx_modal__contents--no-padding'], isFullView), _clsx2), className);
  var titleId = "header_".concat(idBase);
  var titleElement = null;
  var ariaProps = {
    role: 'dialog',
    className: wrapperClasses,
    'aria-modal': 'true',
    'aria-hidden': isHidden ? 'true' : 'false'
  };

  if (hideTitle) {
    ariaProps['aria-label'] = title;
  } else {
    ariaProps['aria-labelledby'] = titleId;
    titleElement = /*#__PURE__*/React.createElement("h2", {
      id: titleId
    }, title);
  }

  var closeButtonContainerClass = isFullView ? 'ppvx_modal__contents--close' : 'ppvx_modal-header__close';
  var closeButton = /*#__PURE__*/React.createElement("div", {
    className: styles[closeButtonContainerClass]
  }, /*#__PURE__*/React.createElement(IconButton, {
    buttonType: isThemeV2 ? 'tertiary' : 'primary',
    theme: _theme,
    svgIconComponent: isThemeV2 ? V2CloseIcon : CloseIcon,
    inverse: showInverseCloseButton,
    onClick: function handleCloseButtonClick(evt) {
      requestClose(evt, 'closeButton');
    },
    "aria-haspopup": "dialog"
  }, closeButtonLabel));
  var footer = footerContents ? /*#__PURE__*/React.createElement("footer", {
    className: clsx(styles['ppvx_modal-footer'], (_clsx3 = {}, _defineProperty(_clsx3, styles['ppvx_modal-footer--scrolled'], footerScroll), _defineProperty(_clsx3, styles["ppvx_modal-footer--align_".concat(footerAlign)], footerAlign), _clsx3), footerClassName)
  }, footerContents) : null;
  var header = /*#__PURE__*/React.createElement("header", {
    className: clsx(styles['ppvx_modal-header'], (_clsx4 = {}, _defineProperty(_clsx4, styles['ppvx_modal-header--scrolled'], headerScroll), _defineProperty(_clsx4, styles['ppvx_modal-header--divider'], divider), _clsx4), headerClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__action']
  }, action), /*#__PURE__*/React.createElement("div", {
    className: styles['ppvx_modal-header__title'],
    id: titleId
  }), closeButton);
  var contents = /*#__PURE__*/React.createElement("div", ariaProps, /*#__PURE__*/React.createElement(FocusOn, {
    enabled: !isHidden // @ts-ignore: onEscapeKey() wants an Event, but the rest of this code wants SyntheticEvent<>
    ,
    onEscapeKey: function handleEscape(evt) {
      evt.preventDefault();
      requestClose(evt, 'ESC');
    },
    onClickOutside: function handleBackdropClick(evt) {
      if (closeOnBackgroundClick) {
        requestClose(evt, 'backdropClick');
      }
    },
    className: styles['ppvx_modal--container_middle']
  }, /*#__PURE__*/React.createElement("article", _extends({
    className: classes
  }, rest), isFullView ? closeButton : header, /*#__PURE__*/React.createElement("section", {
    className: contentClasses,
    onScroll: function scrollChecker() {
      return scrollCheck();
    },
    ref: contentRef
  }, /*#__PURE__*/React.createElement(AutoFocusInside, null, titleElement, children)), footer)));
  var containerElm = containerRef && containerRef.current; // Delay createPortal until component is mounted to fix server side rendering

  return isMounted && ReactDOM.createPortal(contents, containerElm || document.body);
};

var Dialog = function (_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      componentProps = _objectWithoutProperties(_ref, ["isOpen", "onClose"]);

  return /*#__PURE__*/React.createElement(Animator, {
    shouldHide: !isOpen,
    onClose: onClose
  }, function animatee(props) {
    return /*#__PURE__*/React.createElement(DialogComponent, _extends({}, props, componentProps));
  });
};

export { Dialog };
